export const getObjectField = (source, field, value = {}) =>
  source[field] != null && typeof source[field] === 'object'
    ? source[field]
    : value
